<template>
  <div class="form-detail">
    <p class="form-item">
      <span class="form-lt">企业全称</span>
      <span class="form-rt">{{orgdetail.name}}</span>
    </p>
    <p class="form-item" style="margin-bottom:0">
      <span class="form-lt">企业类型</span>
      <span class="form-rt">
        企事业单位
      </span>
    </p>
    <p style="color:#999; margin-left:160px;margin-bottom:22px;">注：企业类型不支持修改，如类型选择错误，请在设置中注销后，重新注册</p>
    <p class="form-item">
      <span class="form-lt">统一社会信用代码</span>
      <span class="form-rt">{{orgdetail.code}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">营业执照</span>
      <span class="form-rt">
        <div style="overflow:hidden;border-radius:5px">
          <!-- <img v-for='img in imgList' style="width:100%;cursor:pointer" :key="img"  alt="" @click="showBigImg(img)" :src='getImgUrl(img)'> -->
          <viewer :images="photo" class="seeBigImg">
            <img
              v-for="(src,index) in photo"
              :src="src"
              :key="index"
            >
          </viewer>
        </div>
        <!-- <el-dialog v-model="previewImg" size="tiny">
          <img width="100%"  alt="" :src='imgName'>
        </el-dialog> -->
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">行业</span>
      <span class="form-rt">{{formatName}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">企业法人</span>
      <span class="form-rt">{{orgdetail.legalPerson}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系电话</span>
      <span class="form-rt">{{orgdetail.phone}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">注册地址</span>
      <span class="form-rt">
        <span class="form-registry">{{orgdetail.cityName}}</span>
      <span class="form-registry">{{orgdetail.countyName}}</span>
      <span class="form-registry">{{orgdetail.address}}</span>
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">中心坐标</span>
      <span class="form-rt">东经：{{orgdetail.longitude | formatDegree}}，北纬：{{orgdetail.latitude | formatDegree}}</span>
    </p>
    <p class="form-item" v-show="names != '不属于工业园'">
      <span class="form-lt">工业园区</span>
      <span class="form-rt">{{names}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">规模</span>
      <span class="form-rt" v-if="orgdetail.regionType==1">单个区县</span>
      <span class="form-rt" v-if="orgdetail.regionType==2">跨区县</span>
      <span class="form-rt" v-if="orgdetail.regionType==3">跨市</span>
    </p>
    <p class="form-item">
      <span class="form-lt">所属区划</span>
      <span class="form-rt">
         <p v-for="m in orgdetail.regions" :key="m.id">
          <span class="form-registry">{{m.city.name}}</span>
      <span class="form-registry" v-for="n in m.county" :key="n.id">{{n.name}}</span>
    </p>
    </span>
    </p>
    <el-button type="info" style="margin-top:20px;margin-left:158px;position:relative;">
      查看一企一码
      <viewer :images="qrcodeList" class="qrcodeImg">
            <img
              v-for="(src,index) in qrcodeList"
              :src="src"
              :key="index"
            >
          </viewer>
    </el-button>
  </div>
</template>
<script>
import weather from '../../data/emer/weather.js'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      imgList: [],
      photo:[],
      imgName: '',
      orgdetail: {
        // 地址
        address: '',
        // 营业执照编号
        code: '',
        // 营业执照图片文件名
        imgName: '',
        //  纬度
        latitude: '',
        // 经度
        longitude: '',
        // 机构名称
        name: '',
        // 电话
        phone: '',
        // 区划
        regions: [],
        // 子类型
        subType: '',
        // 机构类型
        type: '',
        // 三级联动
        RegionPartition: [],

        legalPerson: '',
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        zone: {
          name: ''
        }
      },
      // 浏览大图
      previewImg: false,
      names: '',
      // 行业名称
      formatName: '',
      qrcodeList:[]
    }
  },
  props: {
    dataEnt: {
      type: Object
    }
  },
  created(){
    let subjectId = sessionStorage['currenOrgId']
    let qrcode = `http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`;
    this.qrcodeList.push(qrcode)
  },
  watch: {
    dataEnt() {
      this.initdata()
    }
  },
  methods: {
    ...mapMutations(['dataEntForm']),
    // 初始化详情数据
    initdata() {
      if (this.dataEnt) {
        this.orgdetail = JSON.parse(JSON.stringify(this.dataEnt))
        this.names = this.orgdetail.zone ? this.orgdetail.zone.name : '不属于工业园'
        this.dataEntForm(this.orgdetail)
        if (this.orgdetail.imgName && this.orgdetail.imgName.indexOf(';') !== -1) {
          this.imgList = this.orgdetail.imgName.split(';')
        } else {
          this.imgList.push(this.orgdetail.imgName)
        }

        for(var i = 0; i <this.imgList.length;i++ ){
          let fullPath = this.getImgUrl(this.imgList[i]);
          this.photo.push(fullPath)
        }

        if (this.orgdetail.industry == null) {
          return
        } else {
          this.formatName = JSON.parse(JSON.stringify(this.orgdetail.industry)).name
        }
      }
    },
    getImgUrl(name) {
      const TOKEN = sessionStorage.getItem('publicToken')
      if (!name) {
        return './../../../static/img/000.png'
      }
      if (name) {
        return `/api/basic/img/get?name=${name}&AccessToken=${TOKEN}`
      }
    },
    showBigImg(file) {
      this.imgName = this.getImgUrl(file);
      this.previewImg = true;
    },
    // 格式化中文
    nameformat(val) {
      // console.log(val, '2')
    },
    openqrcode () {
      // (async() => {
        let subjectId = sessionStorage['currenOrgId']
      //   let qrcode = await weather.get_qecode({
      //     subjectId: subjectId,
      //   })
      // })()
      window.open(`http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`)
    }
  },
  destroyed() {
    this.orgdetail = ''
  },
}

</script>
<style lang="stylus" scoped>
.form-detail {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  color: #48576a;
  font-size: 14px;
  .form-item {
    margin-bottom: 22px;
    min-height: 36px;
    line-height: 36px;
    display: flex;
    .form-lt {
      width: 120px;
      padding-right: 12px;
      margin-right: 40px;
      box-sizing: border-box;
      text-align: right;
    }
    .form-rt {
      flex: 1;
      .form-registry {
        margin-right: 30px;
      }
      .form-region {
        padding: 5px 30px;
        border: 1px solid #48576a;
        line-height: 30px
      }
    }
  }
}

.seeBigImg {
  width:auto;
  img {
    width:180px;
  }
}

.qrcodeImg {
  position:absolute;
  top:0;
  left :0;
  right:0;
  bottom:0;
  img {
    opacity:0;
    width :100%;
    height :100%;
  }
}

</style>



// WEBPACK FOOTER //
// Entdetail.vue?d329e0e2